import React from 'react';
import notEmpty from '../../util/notEmpty';
import formatDate from '../../util/formatDate';
import formatTime from '../../util/formatTime';
import ReactExport from 'react-export-excel';
import notEmptyString from '../../util/notEmptyString';

const ExcelChangeRequest = props => {
	const {dbUser, data} = props;

	const ExcelFile = ReactExport.ExcelFile;
	const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
	const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

	const prefix = dbUser.aanbieders.find(row => {
		return row.id === dbUser.aanbieder;
	});

	return (
		<ExcelFile
			filename={prefix.label + ' ' + prefix.naam + ' - Verzoeken om wijziging'}
			element={
				<button className='button download'>
					<strong>Excel</strong>
				</button>
			}>
			<ExcelSheet data={data} name='Verzoeken om wijziging'>
				<ExcelColumn label='Gemeente' value='gemeente_naam' />
				<ExcelColumn label='Cliënt' value='naam' />
				<ExcelColumn
					label='Status'
					value={col =>
						notEmpty(col.status)
							? col.status === 1
								? 'Aangemaakt'
								: col.status === 2
									? 'Ingediend'
									: col.status === 3
										? 'Goedgekeurd'
										: col.status === 4
											? 'Afgekeurd'
											: col.status === 5
												? 'Toegewezen'
												: col.status === 6
													? 'Afgewezen'
													: col.status === 7
														? 'In onderzoek'
														: 'Onbekend'
							: ''
					}
				/>
				<ExcelColumn label='Datum en tijd' value={col => (notEmpty(col.status_ts) ? formatDate(col.status_ts, 2) + ', ' + formatTime(col.status_ts, 2) : '')} />
				<ExcelColumn label='Retourcodes' value='retourcodes' />
				<ExcelColumn label='Reden' value='reden_label' />
				<ExcelColumn label='Toewijzingen' value='aantal_toewijzingen' />
				<ExcelColumn label='Ongewijzigd' value='aantal_ongewijzigd' />
				<ExcelColumn label='Gewijzigd' value='aantal_gewijzigd' />
				<ExcelColumn label='Nieuw' value='aantal_nieuw' />
				<ExcelColumn label='Openstaand' value={col => (notEmptyString(col.openstaand) ? (col.openstaand === null ? 'Ja' : 'Nee') : '')} />
			</ExcelSheet>
		</ExcelFile>
	);
};

export default ExcelChangeRequest;
